import React from 'react';
import clsx from 'clsx';
import { ReactComponent as PiggyBankIllustration } from 'common-assets/assets/illustrations/piggy-bank-riding.svg';
import { Card, Icon, Typography } from 'ui-components';
import { RetirementCalculatorPromoCardPropsModel } from '../../tools/RetirementCalculator.model';

import useStyles from './RetirementCalculatorPromoCard.style';

export const RetirementCalculatorPromoCard: React.FC<RetirementCalculatorPromoCardPropsModel> = ({
  variant = 'wide',
  badge,
  title,
  description,
  descriptionClassName,
  testId,
}) => {
  const c = useStyles({});
  const isWide = variant === 'wide';

  return (
    <Card
      className={clsx(c.promoCard, isWide ? c.promoCardWide : c.promoCardCompact)}
      testId={testId}
    >
      <div className={clsx(c.promoText, !isWide && c.promoTextCompact)}>
        <span className={c.promoBadge} data-testid={testId && `${testId}-badge`}>
          {badge}
        </span>
        <Typography
          variant="caption"
          component="h2"
          fontWeight="extraBold"
          textColor="maroons.100"
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={clsx(c.promoDescription, descriptionClassName)}
        >
          {description}
        </Typography>
      </div>
      <Icon
        className={clsx(
          c.promoIllustration,
          isWide ? c.promoIllustrationWide : c.promoIllustrationCompact,
        )}
      >
        <PiggyBankIllustration />
      </Icon>
    </Card>
  );
};
